import  React from "react";
import { Container, Button } from "shards-react";
import { Link } from "react-router-dom";

const NotFound = () => (
    <Container fluid className="main-content-container px-4 pb-4">
        <div className="error">
            <div className="error__content">
                <h6>404</h6>
                <h2>OUPSSS !</h2>
                <h3>Hey ! Vous êtes perdu ! La page vous cherchez n'existe pas ! =(</h3>
                <Link to={"/dashboard"} ><Button pill>  &larr; Retourner sur l'accueil </Button></Link>
            </div>
        </div>
    </Container>
);

export default NotFound;


// WEBPACK FOOTER //
// ./src/views/Errors/404.js